import Vue from 'vue'
import VueRouter from 'vue-router'
import routesMap from "./routesMap"



Vue.use(VueRouter)

const routes = [
    ...routesMap
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.$addRoutes = (params) => {
    router.matcher = new VueRouter({mode: 'history'}).matcher;
    router.addRoutes(params)
}

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.name) {
        //document.title = to.name+'-北京康柏汉森医药科技咨询有限责任公司';
        document.title = to.name
    }
    next();
})

export default router
